import { Fragment } from 'react';

import type { Step } from '@sorare/core/src/components/StepperDialog';

import type { LadderPointsStory_ladderContribution } from './__generated__/index.graphql.ts';
import { LadderPointsStory } from './index.tsx';

export const ladderPointsSteps = (
  ladderContribution: LadderPointsStory_ladderContribution | undefined
): Step[] =>
  ladderContribution
    ? [
        {
          bodyElement: ({ onNext }) => (
            <Fragment key="ladder-points-story">
              <LadderPointsStory
                ladderContribution={ladderContribution}
                onClose={onNext}
              />
            </Fragment>
          ),
        },
      ]
    : [];

ladderPointsSteps.fragments = {
  ladderContribution: LadderPointsStory.fragments.ladderContribution,
};
